import { Component } from '@angular/core'
import {
  MbCheckoutBaseFormPartialComponent
} from '../mb-checkout-base-form-partial/mb-checkout-base-form-partial.component'

@Component({
  selector: 'mb-checkout-vat-id-form-partial',
  templateUrl: './mb-checkout-vat-id-form-partial.component.html',
})
export class MbCheckoutVatIdFormPartialComponent extends MbCheckoutBaseFormPartialComponent {
}
